export const BackgroundCheckPayment = {
  HeaderText: 'header-text',
  SubmitBtn: 'submit-btn',
  SubHeaderText: 'subheader-text',
  SkipLineModal: 'skip-line-modal',
  DiscountText: 'discount-text',
  DiscountBanner: 'dicount-banner',
};
